import { render, staticRenderFns } from "./QualificationType.vue?vue&type=template&id=7f663cd5"
import script from "./QualificationType.vue?vue&type=script&lang=js"
export * from "./QualificationType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports